<template>
    <span>
         <a href="#" data-toggle="modal" data-target="#popupi" @click="showDiscussionPopup">
            <div class="btn-group pair_btn_new_uniq">
                <div class="d-inline clickable">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_3764_102149)">
                    <path d="M15 4V11H5.17L4.58 11.59L4 12.17V4H15ZM16 2H3C2.45 2 2 2.45 2 3V17L6 13H16C16.55 13 17 12.55 17 12V3C17 2.45 16.55 2 16 2ZM21 6H19V15H6V17C6 17.55 6.45 18 7 18H18L22 22V7C22 6.45 21.55 6 21 6Z" fill="#2E4051"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_3764_102149">
                    <rect width="24" height="24" fill="white"/>
                    </clipPath>
                    </defs>
                    </svg>

                </div>
        </div>
        </a>
    </span>
</template>
<script>
export default {
    name: "CustomerChatBtn",
    props: ['theme','discussion_lnk'],
    methods: {
        showDiscussionPopup(){
            window.popupi('Customer Discussion', this.discussion_lnk);
        },
    }
}
</script>